/* eslint-disable */
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { DELIVERY_PERSIST_KEY } from '../Constants/Delivery/Delivery.constants';
import { FILTER_PERSIST_KEY } from '../Constants/Filter/Filter.constants';
import { I18N_PERSIST_KEY } from '../Constants/I18n/I18n.constants';
import { ORDER_PERSIST_KEY } from '../Constants/Order/Order.constants';
import { SIDEBAR_PERSIST_KEY } from '../Constants/Sidebar/Sidebar.constants';
import { THEME_PERSIST_KEY } from '../Constants/Theme/Theme.constants';
import { USER_PROFILE_PERSIST_KEY } from '../Constants/UserProfile/UserProfile.constants';
import authReducer from './Store/Auth/Auth.reducer';
import deliveriesReducer from './Store/Deliveries/Deliveries.reducer';
import docketsReducer from './Store/Dockets/Dockets.reducer';
import filtersReducer from './Store/Filters/Filters.reducer';
import i18nReducer from './Store/I18n/I18n.reducer';
import ordersReducer from './Store/Orders/Orders.reducer';
import sidebarReducer from './Store/Sidebar/Sidebar.reducer';
import themeReducer from './Store/Theme/Theme.reducer';
import userProfileReducer from './Store/UserProfile/UserProfile.reducer';
import createNotificationReducer from './Store/Notification/Notification.reducer';
import createSnackbarStoreReducer from './Store/Snackbar/SnackbarStore.reducer';
import createPlusLoadModalStoreReducer from './Store/PlusLoadModal/PlusLoadModal.reducer';
import createPlusLoadExceptionModalStoreReducer, { REDUX_PLUS_LOAD_EXCEPTION_MODAL_STORE_KEY } from './Store/PlusLoadExceptionModal/PlusLoadExceptionModal.reducer';

/**
 * Combine the reducers with [immutability](https://github.com/gajus/redux-immutable#problem) in mind
 * @param {Services} services The services to inject into the reducers. **NOT** THE STORE.
 * @param {Entry} entry The entry to inject into the reducers. **NOT** THE STORE.
 * @param {ReactHistory} history The history implementation
 * @returns {Reducer} The route aware reducers
 */
const createReducers = (services, entry, history) => {
  /** @type {InjectablesForReducer} */
  const injectables = { ...services, entry };
  const combinedReducer = combineReducers({
    auth: authReducer(injectables),
    deliveries: persistReducer({
      key: DELIVERY_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, deliveriesReducer(injectables)),
    dockets: docketsReducer(injectables),
    filters: persistReducer({
      key: FILTER_PERSIST_KEY, stateReconciler: false, storage: services.storageService }, filtersReducer(injectables)
    ),
    i18n: persistReducer({
      key: I18N_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, i18nReducer(injectables)
    ),
    orders: persistReducer({
      key: ORDER_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, ordersReducer(injectables)
    ),
    sidebar: persistReducer({
      key: SIDEBAR_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, sidebarReducer(injectables)
    ),
    theme: persistReducer({
      key: THEME_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, themeReducer(injectables)
    ),
    userProfile: persistReducer({
      key: USER_PROFILE_PERSIST_KEY,
      stateReconciler: false,
      storage: services.storageService,
    }, userProfileReducer(injectables)
    ),
    'notificationStore': createNotificationReducer(),
    'snackbarStore': createSnackbarStoreReducer(),
    'plusLoadModalStore': createPlusLoadModalStoreReducer(),
    [REDUX_PLUS_LOAD_EXCEPTION_MODAL_STORE_KEY]: createPlusLoadExceptionModalStoreReducer(),
  });
  return connectRouter(history)(combinedReducer);
};

export default createReducers;
